import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import PrivacyStatement from "./pages/PrivacyStatement";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="privacy-statement" element={<PrivacyStatement />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
